module.exports = __webpack_public_path__ + "img/momo-mobile.59782285.png";